







































































































import {Component, Prop, Vue} from 'vue-property-decorator';

import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import {RoadwayClassifications} from '@/lib/data/roadwayClassification';
import {DesignScenarioType} from '@/modules/design/interfaces/shared';
import {states} from '@/lib/data/states';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';

@Component({
  components: {
    ValidatedInputPageWrapper,
    PxNumberInput,
    InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
  // validations: {
  //   scenario: {
  //     name: {
  //       required
  //     },
  //     completionYear: {
  //       minValue: minValue(new Date(Date.now()).getFullYear() - 100),
  //       maxValue: maxValue(new Date(Date.now()).getFullYear() + 100)
  //     },
  //     roadwayClassification: {
  //       required
  //     }
  //   }
  // }
})
export default class BaseScenarioInfo extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  @Prop() scenario!: any;

  @Prop() saveFcn!: Function;

  @Prop() validations!: any;

  // @Prop() validationGroup!: any;

  save() {
    // this.v.$touch();
    this.$emit('save');
  }

  sync() {
    this.$emit('sync');
  }

  get useValidatedWrapper() {
    return [
      DesignScenarioType.asphalt,
      DesignScenarioType.concrete,
      DesignScenarioType.porous,
      DesignScenarioType.acOverlay,
    ].includes(this.scenario.designScenarioType);
  }

  designScenarioTypes = DesignScenarioType;

  roadwayTypeMap = {
    [RoadwayClassifications.parkingLotLight]: 'Parking Lot - Light Duty',
    [RoadwayClassifications.parkingLotHeavy]: 'Parking Lot - Heavy Duty',
    [RoadwayClassifications.arterial]: 'Principle Arterial',
    [RoadwayClassifications.interstate]: 'Interstate and other Freeways',
    [RoadwayClassifications.residential]: 'Collectors',
    [RoadwayClassifications.local]: 'Local',

  };

  roadwayClassificationOptions: { value: string, text: string }[] = Object.values(RoadwayClassifications).map((v) => ({
    value: v,
    text: this.roadwayTypeMap[v],
  })).filter((x) => {
    // Only allow light duty parking lot for asphalt pavements
    if (x.value === RoadwayClassifications.parkingLotLight && this.scenario.designScenarioType !== DesignScenarioType.asphalt) {
      return false;
    }
    return true;
  });
  // [
  // {value: 1, text: "Parking Lot - Light Duty"},
  // {value: 2, text: "Parking Lot - Heavy Duty"},
  // {value: 3, text: "Residential/Collector"},
  // {value: 4, text: "Local"},
  // {value: 5, text: "Arterials/Highway"},
  // {value: 6, text: "Interstate"},
  // ];

  setRoadwayClassification() {
    const c = this.scenario.roadwayClassification;
    console.log('clas', c);


    // Get the default params
    const d = this.defaults[c]; // [this.scenario.designScenarioType];
    console.log(d);

    switch (this.scenario.designScenarioType) {
      case DesignScenarioType.asphalt:
        Object.assign(this.scenario, d['New - Asphalt']);
        break;
      case DesignScenarioType.concrete:
        Object.assign(this.scenario, d['New - Concrete']);
        break;
      case DesignScenarioType.porous:
        break;
      case DesignScenarioType.acOverlay:
        Object.assign(this.scenario, d['AC Overlay on Asphalt']);
        break;
    }

    this.sync();
  }

  defaults: any = {
    'Parking Lot - Light Duty': {
      'New - Asphalt': {
        designPeriod_years: 10,
        reliabilityLevel: 50,
      },
      'New - Concrete': {
        designPeriod_years: 10,
        reliabilityLevel: 50,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 50,
      },
    },
    'Parking Lot - Heavy Duty': {
      'New - Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'New - Concrete': {
        designPeriod_years: 15,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
    },
    'Residential/Collector': {
      'New - Asphalt': {
        designPeriod_years: 20,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'New - Concrete': {
        designPeriod_years: 20,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 50,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
    },
    Local: {
      'New - Asphalt': {
        designPeriod_years: 20,
        reliabilityLevel: 75,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'New - Concrete': {
        designPeriod_years: 20,
        reliabilityLevel: 75,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 75,
        initialServiceability: 4.5,
        terminalServiceability: 2.0,
        deltaServiceability: 2.5,
      },
    },
    'Arterials/Highway': {
      'New - Asphalt': {
        designPeriod_years: 30,
        reliabilityLevel: 85,
      },
      'New - Concrete': {
        designPeriod_years: 30,
        reliabilityLevel: 85,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 85,
      },
    },
    Interstate: {
      'New - Asphalt': {
        designPeriod_years: 40,
        reliabilityLevel: 95,
      },
      'New - Concrete': {
        designPeriod_years: 40,
        reliabilityLevel: 95,
      },
      'AC Overlay on Asphalt': {
        designPeriod_years: 15,
        reliabilityLevel: 95,
      },
    },
  };

  stateOptions = states;// Object.keys(weatherData).map(k => {return {value:k, text:k}})
}

